import React, { useEffect, useState } from "react";
import "./registration.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { Modal, Box } from "@material-ui/core";
import Googleplay from "../Footer/image/Googleplay.png";
import Applestore from "../Footer/image/appdownloads.png";
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import Accordion from '../CRP/components/Accordion'
import banner from './image/business-registration-banner.jpg'

const faqs = [
  {
    question: "How does your platform source and verify the authenticity of the leads?",
    answer: `We guarantee lead authenticity through chat and over-call verification. Chat interactions gather essential data, while personal calls confirm interest, ensuring that leads delivered to you are genuine and genuinely interested.`,
  },
  {
    question: "What kind of data analytics and insights will I have access to on your platform?",
    answer:`On our platform, you'll gain access to valuable data analytics and insights, including the total number of bids, engagement metrics such as the number of profile views your club receives, and detailed information on your menu and packages. These insights empower you to make informed decisions and optimize your club's offerings effectively.`
  },
  {
    question: "What kind of support and assistance will you offer during the onboarding & integration process?",
    answer: "You'll have a dedicated dashboard for convenience, and we grant access to make changes to the front end. Plus, our 24/7 support is available over call and chat to ensure a smooth and successful integration.",
  },
  {
    question: "How do you ensure that my club's bids for potential customers are competitive and likely to be accepted over other clubs on your dashboard?",
    answer: "Our platform ensures the competitiveness of your club's bids through a two-fold approach. We use chat verification and over-call verification to confirm the authenticity and interest of potential customers. This process maximizes the likelihood of your bids being accepted.",
  },
  {
    question: "How do you measure the success of your service, and what key performance indicators (KPIs) do you track?",
    answer: "We measure the success of our service through several key performance indicators (KPIs) that include lead conversion rates, engagement metrics such as profile views, bid acceptance rates, and overall customer satisfaction.",
  },
  {
    question: "Do you offer any guarantees or refunds if the leads generated do not meet the promised criteria?",
    answer: "We have a unique approach to guaranteeing results. You only pay our commission once a lead converts into a patron for your club. This way, you can be confident that you're investing in leads that genuinely impact your business, ensuring a win-win scenario for both parties",
  },
];


const RegistrationLoginForm = () => {
  const [mobile, setMobile] = useState('');
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [ownerEmail, setOwnerEmail] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [managerMobile, setManagerMobile] = useState('');
  const [isManagerMobileValid, setIsManagerMobileValid] = useState(false);
  const [managerOtp, setManagerOtp] = useState('');
  const [isManagerOtpSent, setIsManagerOtpSent] = useState(false);
  const [isManagerOtpVerified, setIsManagerOtpVerified] = useState(false);
  const [managerOtpError, setManagerOtpError] = useState('');
  const [managerName, setManagerName] = useState('');
  const [managerEmail, setManagerEmail] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('Freemium');
  const [subscriptionDuration, setSubscriptionDuration] = useState('Annual');
  const [showPopup, setShowPopup] = useState(false);
  const [isMobileDisabled, setIsMobileDisabled] = useState(false);
  const [isManagerMobileDisabled, setIsManagerMobileDisabled] = useState(false);
  const [swalProps, setSwalProps] = useState({});

  const [selectedPerson, setSelectedPerson] = useState('owner');


  const handleMobileNumberChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    if (numericValue.length <= 10) {
      setMobile(numericValue);
      setMobile(e.target.value);
      setIsMobileValid(/^\d{10}$/.test(numericValue));
    }
  };

  const handleManagerMobileNumberChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    if (numericValue.length <= 10) {
      setManagerMobile(numericValue);
      setIsManagerMobileValid(/^\d{10}$/.test(numericValue));
    }
  };

  const handleVerifyMobile = async () => {
    if (!isMobileValid) return;

    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('otpType', 'text');

      console.log('Sending mobile verification request with:', { mobile });

      const response = await axios.post(
        'https://partywitty.com/master/Api/getDataPost/verifyMobile',
        formData
      );

      console.log('Mobile verification response:', response.data);

      if (response.data.status) {
        setIsOtpSent(true);
        setOtpError('');
        setIsMobileDisabled(true);
        iziToast.success({
          title: 'Success',
          message: response.data.msg || 'OTP sent successfully!',
          position: 'topCenter',
        });
      } else {
        setOtpError('Failed to send OTP.');
        iziToast.error({
          title: 'Error',
          message: 'Failed to send OTP.',
          position: 'topCenter',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setOtpError('Error occurred while sending OTP.');
      iziToast.error({
        title: 'Error',
        message: 'Error occurred while sending OTP.',
        position: 'topCenter',
      });
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return;

    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('otp', otp);

      console.log('Sending OTP verification request with:', { mobile, otp });

      const response = await axios.post(
        'https://partywitty.com/master/Api/getDataPost/verifyMobileOtp',
        formData
      );

      console.log('OTP verification response:', response.data);

      if (response.data.status) {
        setIsOtpVerified(true);
        setIsOtpSent(false);
        setOtpError('');
        iziToast.success({
          title: 'Success',
          message: 'Mobile number verified successfully!',
          position: 'topCenter',
        });
      } else {
        setOtpError('Incorrect OTP.');
        iziToast.error({
          title: 'Error',
          message: 'Incorrect OTP.',
          position: 'topCenter',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setOtpError('Error occurred while verifying OTP.');
      iziToast.error({
        title: 'Error',
        message: 'Error occurred while verifying OTP.',
        position: 'topCenter',
      });
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setOtpError(''); // Clear any previous errors when OTP is being typed
  };

  const handleVerifyManagerMobile = async () => {
    if (!isManagerMobileValid) return;

    try {
      const formData = new FormData();
      formData.append('mobile', managerMobile);
      formData.append('otpType', 'text');

      const response = await axios.post(
        'https://partywitty.com/master/Api/getDataPost/verifyMobile',
        formData
      );

      if (response.data.status) {
        setIsManagerOtpSent(true);
        setManagerOtpError('');
        setIsManagerMobileDisabled(true);
        iziToast.success({
          title: 'Success',
          message: response.data.msg || 'OTP sent successfully!',
          position: 'topCenter', // Position at the top center
        });
      } else {
        setManagerOtpError('Failed to send OTP.');
        iziToast.error({
          title: 'Error',
          message: 'Failed to send OTP.',
          position: 'topCenter', // Position at the top center
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setManagerOtpError('Error occurred while sending OTP.');
      iziToast.error({
        title: 'Error',
        message: 'Error occurred while sending OTP.',
        position: 'topCenter', // Position at the top center
      });
    }
  };

  const handleVerifyManagerOtp = async () => {
    if (managerOtp.length !== 6) return;
    try {
      const formData1 = new FormData();
      formData1.append('mobile', managerMobile);
      formData1.append('otp', managerOtp);

      const response = await axios.post(
        'https://partywitty.com/master/Api/getDataPost/verifyMobileOtp',
        formData1
      );

      if (response.data.status) {
        setIsManagerOtpVerified(true);
        setIsManagerOtpSent(false);
        setManagerOtpError('');
        iziToast.success({
          title: 'Success',
          message: 'Mobile number verified successfully!',
          position: 'topCenter', // Position at the top center
        });
      } else {
        setManagerOtpError('Incorrect OTP.');
        iziToast.error({
          title: 'Error',
          message: 'Incorrect OTP.',
          position: 'topCenter', // Position at the top center
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setManagerOtpError('Error occurred while verifying OTP.');
      iziToast.error({
        title: 'Error',
        message: 'Error occurred while verifying OTP.',
        position: 'topCenter', // Position at the top center
      });
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append('business_name', businessName || '');
    formData.append('business_address', businessAddress || '');
    formData.append('business_type', selectedBusinessType || '');
    formData.append('subscription', subscriptionType || '');
    formData.append('plan_validity', subscriptionDuration || '');

    if (selectedPerson === 'owner') {
      formData.append('owner_mobile', mobile || null);
      formData.append('owner_name', ownerName || null);
      formData.append('owner_email', ownerEmail || null);
      formData.append('manager_mobile', null);
      formData.append('manager_name', null);
      formData.append('manager_email', null);
    } else {
      formData.append('manager_mobile', managerMobile || null);
      formData.append('manager_name', managerName || null);
      formData.append('manager_email', managerEmail || null);
      formData.append('owner_mobile', null);
      formData.append('owner_name', null);
      formData.append('owner_email', null);
    }


    for (let pair of formData.entries()) {
      console.log("formdata", `${pair[0]}: ${pair[1]}`);
    }


    try {
      const response = await axios.post(
        'https://partywitty.com/master/Api/getDataPost/restaurantsEnquiry',
        formData
      );
      console.log(response.data);

      if (response.data.status === true) {
        // alert("Enquiry submitted successfully!"); // Alert message
        // setShowPopup(true); // Open the popup/modal
        window.location.href = '/business-registration-submitted';
      } else {
        alert("Enquiry submission failed."); // Optional: Handle failed submission
      }
    } catch (error) {
      console.error('Error:', error);
      alert("Error submitting enquiry."); // Alert for error
    }
  };
  const [businessTypes, setBusinessTypes] = useState([]);
  const [selectedBusinessType, setSelectedBusinessType] = useState("");

  useEffect(() => {
    axios
      .get("https://partywitty.com/master/APIs/ClubPackage/getVenuType")
      .then((response) => {
        setBusinessTypes(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const isFormComplete = () => {
    const commonFieldsFilled =
      businessName &&
      businessAddress &&
      selectedBusinessType &&
      subscriptionType &&
      subscriptionDuration;

    if (!commonFieldsFilled) return false;

    if (selectedPerson === 'owner') {
      return (
        ownerName &&
        ownerEmail &&
        mobile.length === 10 &&
        isMobileValid &&
        isOtpVerified
      );
    } else {
      return (
        managerName &&
        managerEmail &&
        managerMobile.length === 10 &&
        isManagerMobileValid &&
        isManagerOtpVerified
      );
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    window.location.href = '/';
  };

  return (
    <div className="login-container">
      <section class="about-banner-section">
        <div class="main--box">
          <div class="title--name">
            <h2>Get More Footfall & <span class="br-banner-title--span">Bookings with PartyWitty</span></h2>
          </div>
        </div>
      </section>
      <section class="main--feacture">
        <form onSubmit={handleSubmit1} className="br-border--box--1">
          <div className="br-main--box--1">
            <div className="br-col--1_8">
              <div className="br-row">
                <h3>Subscription Type</h3>
                <div className="br-col-2-3">
                  <div className="br-form-group1">
                    <select
                      name="subscriptionType"
                      className="br-businessType_data"
                      value={subscriptionType}
                      onChange={(e) => setSubscriptionType(e.target.value)}
                    >
                      <option value="Freemium">Freemium</option>
                      <option value="Gold">Gold</option>
                      <option value="Platinum">Platinum</option>
                    </select>
                  </div>
                  <div className="br-form-group1">
                    <select
                      name="subscriptionDuration"
                      className="br-businessType_data"
                      value={subscriptionDuration}
                      onChange={(e) => setSubscriptionDuration(e.target.value)}
                    >
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Annual">Annual</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="br-main--box--1">
            <div className="br-col--1_8">
              <div className="br-row_11">
                <h3>Restaurant details</h3>
                <div className="br-col--1_8">
                  <div className="br-form-group_1">
                    <input
                      type="text"
                      placeholder="Business Name"
                      name="name"
                      className="br-form-control"
                      value={businessName}
                      onChange={(e) => setBusinessName(e.target.value)}
                    />
                  </div>
                  <div className="br-form-group_1">
                    <input
                      type="text"
                      placeholder="Business Address"
                      name="subject"
                      className="br-form-control"
                      value={businessAddress}
                      onChange={(e) => setBusinessAddress(e.target.value)}
                    />
                  </div>
                </div>
                <div className="br-col">
                  <div className="br-b-r-form-group">
                    <select
                      name="businessType"
                      id="businessType"
                      className="br-businessType_data"
                      value={selectedBusinessType}
                      onChange={(e) => setSelectedBusinessType(e.target.value)}
                    >
                      <option value="">Business Type</option>
                      {businessTypes.map((type, index) => (
                        <option key={index} value={type.name}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Owner/Manager Radio Switch */}
            <div className="br-b-r-radio-toggle">
              <div>
                <span>Are you a business owner or manager?</span>
              </div>
              <div className="br-b-r-radio-toggle-box">
                <label>
                  <input type="radio" checked={selectedPerson === 'owner'} onChange={() => setSelectedPerson('owner')} /> Owner
                </label>
                <label>
                  <input type="radio" checked={selectedPerson === 'manager'} onChange={() => setSelectedPerson('manager')} /> Manager
                </label>
              </div>
            </div>
          </div>

          {selectedPerson === 'owner' ? (
            <div className="br-main--box--1">
              <div className="br-col--1_8">
                <div className="br-row">
                  <h3>Owner Details</h3>
                  <p>These will be used to share revenue related communications</p>
                  <div className="br-col--1--2-owner-manager">
                    <input
                      className="br-form-control-input"
                      placeholder="Business Owner Mobile Number"
                      type="number"
                      value={mobile}
                      maxLength="10"
                      onChange={handleMobileNumberChange}
                      pattern="[0-9]*"
                      title="Please enter only numbers"
                      style={{ backgroundColor: isMobileValid ? 'white' : '' }}
                      disabled={isMobileDisabled}
                    />
                    {!isOtpVerified ? (
                      isOtpSent ? (
                        <>
                          <input
                            className="br-form-control-otp"
                            placeholder="Enter OTP"
                            type="number"
                            value={otp}
                            onChange={handleOtpChange}
                            style={{ backgroundColor: otp.length === 6 ? 'white' : '' }}
                          />
                          <button
                            type="button"
                            className="br-form-control-btn"
                            onClick={handleVerifyOtp}
                            style={{
                              backgroundColor: otp.length === 6 ? '#d71362' : '',
                              cursor: otp.length === 6 ? 'pointer' : 'not-allowed',
                            }}
                          >
                            Verify OTP
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="br-form-control-btn"
                          onClick={handleVerifyMobile}
                          style={{
                            backgroundColor: isMobileValid ? '#d71362' : '',
                            cursor: isMobileValid ? 'pointer' : 'not-allowed',
                          }}
                        >
                          Verify
                        </button>
                      )
                    ) : (
                      <button
                        type="button"
                        className="br-form-control-btn"
                        disabled
                        style={{
                          backgroundColor: '#d71362',
                        }}
                      >
                        Verified
                      </button>
                    )}
                  </div>

                  <div className="br-col--1--2-1">
                    <input type="checkbox" />
                    <p>
                      Yes, I would like to receive important updates and notifications from PartyWitty on my WhatsApp
                    </p>
                  </div>
                  <div className="br-col--1">
                    <div className="br-form-group_1">
                      <input
                        placeholder="Business Owner Full Name"
                        name="ownerName"
                        className="br-form-control"
                        value={ownerName}
                        onChange={(e) => setOwnerName(e.target.value)}
                      />
                    </div>
                    <div className="br-form-group_1">
                      <input
                        type="email"
                        placeholder="Business Owner Email"
                        name="email"
                        className="br-form-control"
                        value={ownerEmail}
                        onChange={(e) => setOwnerEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="br-main--box--1">
              <div className="br-col--1_8">
                <div className="br-row">
                  <h3>Manager details</h3>
                  <p>These will be used to share revenue related communications</p>
                  <div>
                    <div className="br-col--1--2-owner-manager">
                      <input
                        type="tel"
                        placeholder="Manager Mobile Number"
                        name="mobileNumber"
                        value={managerMobile}
                        onChange={handleManagerMobileNumberChange}
                        className="br-form-control-input"
                        style={{ backgroundColor: isManagerMobileValid ? 'white' : '' }}
                        required
                        disabled={isManagerMobileDisabled}
                      />
                      {!isManagerOtpVerified ? (
                        isManagerOtpSent ? (
                          <>
                            <input
                              className="br-form-control-otp"
                              placeholder="Enter OTP"
                              type="number"
                              value={managerOtp}
                              onChange={(e) => setManagerOtp(e.target.value)}
                              style={{ backgroundColor: managerOtp.length === 6 ? 'white' : '' }}
                            />
                            <button
                              type="button"
                              className="br-form-control-btn"
                              onClick={handleVerifyManagerOtp}
                              style={{
                                backgroundColor: managerOtp.length === 6 ? '#d71362' : '',
                                cursor: managerOtp.length === 6 ? 'pointer' : 'not-allowed'
                              }}
                            >
                              Verify OTP
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="br-form-control-btn"
                            onClick={handleVerifyManagerMobile}
                            style={{
                              backgroundColor: isManagerMobileValid ? '#d71362' : '',
                              cursor: isManagerMobileValid ? 'pointer' : 'not-allowed'
                            }}
                          >
                            Verify
                          </button>
                        )
                      ) : (
                        <button
                          type="button"
                          className="br-form-control-btn"
                          disabled
                          style={{
                            backgroundColor: '#d71362'
                          }}
                        >
                          Verified
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="br-col--1--2-1">
                    <input type="checkbox"></input>
                    <p>
                      Yes, I would like to receive important updates and notifications from PartyWitty on my WhatsApp
                    </p>
                  </div>

                  <div className="br-col--1">
                    <div className="br-form-group_1">
                      <input
                        placeholder="Manager Full Name"
                        name="managerName"
                        className="br-form-control"
                        value={managerName}
                        onChange={(e) => setManagerName(e.target.value)}
                      ></input>
                    </div>
                    <div className="br-form-group_1">
                      <input
                        type="email"
                        placeholder="Manager Email"
                        name="managerEmail"
                        className="br-form-control"
                        value={managerEmail}
                        onChange={(e) => setManagerEmail(e.target.value)}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div>
            <div className="br-col-md-12 br-text-right">
              <button
                type="submit"
                className="br-btn--theame--1"
                onClick={handleSubmit1}
                disabled={!isFormComplete()}
                style={{
                  backgroundColor: isFormComplete() ? '#d71362' : '#cdcdcd',
                  cursor: isFormComplete() ? 'pointer' : 'not-allowed'
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </form>

        <Modal open={showPopup} onClose={handleClosePopup}>
          <div className="modal-container">
            <div className="modal-content">
              <button
                className="modal-button"
                onClick={() => setShowPopup(false)}
              >
                x
              </button>
              <dotlottie-player
                src="https://lottie.host/6b9fc96a-5c59-464a-ad26-5782e3a54022/EFWiS28KVM.json"
                background="transparent"
                speed="1"
                style={{ height: "300px" }}
                loop
                autoplay
              ></dotlottie-player>
              <p className="modal-message">Form submitted successfully!</p>
              <div className="about-us-playstore-image">
                <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                  <img src={Googleplay} alt="playstore" />
                </Link>
                <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                  <img src={Applestore} alt="appstore" />
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      <section className="br-section-faqs">
        <div className="br-container-faqs">
        <Accordion faqs={faqs} />
        </div>
      </section>
      </section>
    </div>
  );
};

export default RegistrationLoginForm;
